export default "__VITE_ASSET__CsxnNu_c__"